import { render } from "./PropertyBehavior.vue?vue&type=template&id=0da043c7&scoped=true&ts=true"
import script from "./PropertyBehavior.vue?vue&type=script&lang=ts"
export * from "./PropertyBehavior.vue?vue&type=script&lang=ts"

import "./PropertyBehavior.vue?vue&type=style&index=0&id=0da043c7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da043c7"]])

export default __exports__